import { Base } from '../base-component';
import './image-with-large-text-right.component.scss';

export class ImageWithLargeTextRight extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}

}


// WEBPACK FOOTER //
// ./components/image-with-large-text-right/image-with-large-text-right.component.ts